import React from "react";

const Facebook = () => {
  return (
    <svg width={12} height={21} fill="none">
      <path
        d="m10.894 11.302.57-3.62h-3.51V5.326c0-.99.49-1.957 2.057-1.957h1.618V.286A19.62 19.62 0 0 0 8.78.043C5.89.043 4.005 1.78 4.005 4.92v2.761H.8v3.621h3.203v8.759h3.95v-8.759h2.94Z"
        fill="#fff"
      />
    </svg>
  );
};

const InstagramVector = () => {
  return (
    <svg width={21} height={21} fill="none">
      <path
        d="M6.671 10.051a3.336 3.336 0 1 1 3.335 3.337 3.336 3.336 0 0 1-3.335-3.337Zm-1.803 0a5.139 5.139 0 1 0 10.276 0 5.139 5.139 0 1 0-10.276 0Zm9.279-5.343a1.202 1.202 0 1 0 1.2-1.2 1.2 1.2 0 0 0-1.2 1.2Zm-8.183 13.49c-.976-.044-1.506-.207-1.859-.344a3.11 3.11 0 0 1-1.15-.749 3.088 3.088 0 0 1-.749-1.15c-.137-.352-.3-.883-.344-1.859-.049-1.055-.058-1.372-.058-4.045 0-2.672.01-2.988.058-4.044.044-.976.208-1.506.344-1.859.182-.467.399-.8.748-1.151.35-.35.683-.568 1.151-.749.353-.137.883-.3 1.859-.344 1.054-.049 1.371-.058 4.042-.058 2.67 0 2.988.01 4.044.058.975.044 1.505.208 1.858.344a3.1 3.1 0 0 1 1.15.749c.351.35.567.684.75 1.151.137.352.299.883.343 1.859.049 1.056.059 1.372.059 4.044 0 2.673-.01 2.99-.059 4.045-.044.976-.207 1.506-.344 1.859-.182.467-.398.8-.748 1.15-.35.35-.684.567-1.151.75-.352.136-.883.299-1.858.343-1.055.049-1.372.059-4.044.059-2.672 0-2.988-.01-4.042-.059ZM5.88.103C4.816.152 4.088.321 3.452.568a4.908 4.908 0 0 0-1.773 1.154A4.89 4.89 0 0 0 .525 3.495C.278 4.132.11 4.86.061 5.925.01 6.992 0 7.333 0 10.05c0 2.719.011 3.06.06 4.127.05 1.065.218 1.793.465 2.43A4.892 4.892 0 0 0 1.68 18.38a4.921 4.921 0 0 0 1.773 1.155c.637.247 1.364.416 2.429.465 1.067.048 1.408.06 4.125.06s3.058-.011 4.125-.06c1.066-.049 1.793-.218 2.429-.465a4.921 4.921 0 0 0 1.773-1.155 4.903 4.903 0 0 0 1.154-1.773c.247-.636.417-1.364.464-2.43.049-1.067.06-1.407.06-4.126 0-2.718-.011-3.059-.06-4.126-.048-1.066-.217-1.794-.464-2.43a4.922 4.922 0 0 0-1.154-1.773A4.896 4.896 0 0 0 16.56.568c-.637-.247-1.364-.417-2.429-.465-1.067-.048-1.408-.06-4.125-.06-2.718 0-3.059.01-4.126.06Z"
        fill="#fff"
      />
    </svg>
  );
};

const Instagram = () => {
  return (
    <svg width={800} height={800} fill="none" viewBox="0 0 32 32">
      <rect width={28} height={28} x={2} y={2} fill="url(#a)" rx={6} />
      <rect width={28} height={28} x={2} y={2} fill="url(#b)" rx={6} />
      <rect width={28} height={28} x={2} y={2} fill="url(#c)" rx={6} />
      <path fill="#fff" d="M23 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6 15.6c0-3.36 0-5.04.654-6.324a6 6 0 0 1 2.622-2.622C10.56 6 12.24 6 15.6 6h.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C26 10.56 26 12.24 26 15.6v.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C21.44 26 19.76 26 16.4 26h-.8c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C6 21.44 6 19.76 6 16.4v-.8ZM15.6 8h.8c1.713 0 2.878.002 3.778.075.877.072 1.325.202 1.638.361a4 4 0 0 1 1.748 1.748c.16.313.29.761.36 1.638.074.9.076 2.065.076 3.778v.8c0 1.713-.002 2.878-.075 3.778-.072.877-.202 1.325-.361 1.638a4 4 0 0 1-1.748 1.748c-.313.16-.761.29-1.638.36-.9.074-2.065.076-3.778.076h-.8c-1.713 0-2.878-.002-3.778-.075-.877-.072-1.325-.202-1.638-.361a4 4 0 0 1-1.748-1.748c-.16-.313-.29-.761-.36-1.638C8.001 19.278 8 18.113 8 16.4v-.8c0-1.713.002-2.878.075-3.778.072-.877.202-1.325.361-1.638a4 4 0 0 1 1.748-1.748c.313-.16.761-.29 1.638-.36.9-.074 2.065-.076 3.778-.076Z"
        clipRule="evenodd"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-55.376 27.916 .066) scale(25.5196)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B13589" />
          <stop offset={0.793} stopColor="#C62F94" />
          <stop offset={1} stopColor="#8A3AC8" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-65.136 29.766 6.89) scale(22.5942)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0E8B7" />
          <stop offset={0.445} stopColor="#FB8A2E" />
          <stop offset={0.715} stopColor="#E2425C" />
          <stop offset={1} stopColor="#E2425C" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(38.50003 -5.5 1.1764 8.23476 .5 3)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.157} stopColor="#406ADC" />
          <stop offset={0.468} stopColor="#6A45BE" />
          <stop offset={1} stopColor="#6A45BE" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
};

const Youtube = () => {
  return (
    <svg width={24} height={16} fill="none">
      <path
        d="M23.125 2.498A2.864 2.864 0 0 0 21.108.476C19.331 0 12.2 0 12.2 0S5.073 0 3.292.476a2.864 2.864 0 0 0-2.017 2.022C.8 4.28.8 8 .8 8s0 3.72.475 5.502a2.864 2.864 0 0 0 2.017 2.022C5.073 16 12.2 16 12.2 16s7.131 0 8.909-.476a2.863 2.863 0 0 0 2.016-2.022C23.6 11.72 23.6 8 23.6 8s0-3.72-.475-5.502Z"
        fill="#fff"
      />
      <path d="M9.922 11.43 15.845 8 9.922 4.57v6.86Z" fill="#000" />
    </svg>
  );
};

const Twitter = () => {
  return (
    <svg width={22} height={18} fill="none">
      <path
        d="M20.927 2.667a8.363 8.363 0 0 1-2.066.59c.333-.057.822-.656 1.017-.899.296-.365.521-.783.665-1.23 0-.034.033-.082 0-.105a.114.114 0 0 0-.11 0c-.772.418-1.593.737-2.445.95a.171.171 0 0 1-.171-.043 2.375 2.375 0 0 0-.214-.223 4.454 4.454 0 0 0-1.168-.756 4.105 4.105 0 0 0-1.82-.3 4.4 4.4 0 0 0-1.728.476 4.48 4.48 0 0 0-1.368 1.16 4.393 4.393 0 0 0-.83 1.664 4.572 4.572 0 0 0-.043 1.758c0 .1 0 .114-.086.1-3.386-.499-6.164-1.702-8.434-4.283-.1-.114-.152-.114-.233 0-.988 1.502-.508 3.88.727 5.053.166.157.337.31.517.452a4.238 4.238 0 0 1-1.624-.452c-.095-.062-.147-.028-.152.086a2.803 2.803 0 0 0 0 .475 4.318 4.318 0 0 0 2.66 3.442c.172.073.352.13.536.166a4.856 4.856 0 0 1-1.59.047c-.115-.023-.158.038-.115.148.698 1.901 2.213 2.481 3.325 2.804.152.024.304.024.475.062l-.029.029c-.328.599-1.653 1.003-2.26 1.212a8.12 8.12 0 0 1-3.467.446c-.186-.028-.228-.023-.276 0-.047.024 0 .076.052.124.238.157.475.295.722.428.735.401 1.513.72 2.318.95 4.17 1.15 8.862.305 11.991-2.809 2.46-2.443 3.325-5.813 3.325-9.188 0-.128.156-.204.247-.27a8.156 8.156 0 0 0 1.629-1.703.5.5 0 0 0 .114-.342c0-.071 0-.057-.09-.019Z"
        fill="#fff"
      />
    </svg>
  );
};

const WhatsApp = () => {
  return (
    <svg xmlSpace="preserve" width={800} height={800} viewBox="0 0 58 58">
      <path
        d="m0 58 4.988-14.963A28.35 28.35 0 0 1 1 28.5C1 12.76 13.76 0 29.5 0S58 12.76 58 28.5 45.24 57 29.5 57a28.373 28.373 0 0 1-13.26-3.273L0 58z"
        style={{
          fill: "#2cb742",
        }}
      />
      <path
        d="M47.683 37.985c-1.316-2.487-6.169-5.331-6.169-5.331-1.098-.626-2.423-.696-3.049.42 0 0-1.577 1.891-1.978 2.163-1.832 1.241-3.529 1.193-5.242-.52l-3.981-3.981-3.981-3.981c-1.713-1.713-1.761-3.41-.52-5.242.272-.401 2.163-1.978 2.163-1.978 1.116-.627 1.046-1.951.42-3.049 0 0-2.844-4.853-5.331-6.169a2.726 2.726 0 0 0-3.203.482l-1.758 1.758c-5.577 5.577-2.831 11.873 2.746 17.45l5.097 5.097 5.097 5.097c5.577 5.577 11.873 8.323 17.45 2.746l1.758-1.758a2.728 2.728 0 0 0 .481-3.204z"
        style={{
          fill: "#fff",
        }}
      />
    </svg>
  );
};

const Gmail = () => {
  return (
    <svg width={800} height={800} fill="none" viewBox="0 0 32 32">
      <path
        fill="#fff"
        d="M2 11.956c0-3.485 0-5.228.678-6.559a6.222 6.222 0 0 1 2.72-2.719C6.727 2 8.47 2 11.955 2h8.088c3.485 0 5.228 0 6.559.678a6.222 6.222 0 0 1 2.719 2.72C30 6.727 30 8.47 30 11.955v8.088c0 3.485 0 5.228-.678 6.559a6.222 6.222 0 0 1-2.72 2.719C25.273 30 23.53 30 20.045 30h-8.088c-3.485 0-5.228 0-6.559-.678a6.222 6.222 0 0 1-2.719-2.72C2 25.273 2 23.53 2 20.045v-8.088Z"
      />
      <path
        fill="#EA4335"
        d="m22.052 8.523-5.988 4.672L9.94 8.523v.001l.008.007v6.542l6.047 4.774 6.057-4.59V8.524Z"
      />
      <path
        fill="#FBBC05"
        d="m23.623 7.386-1.572 1.137v6.735l4.947-3.799V9.171s-.6-3.268-3.375-1.785Z"
      />
      <path
        fill="#34A853"
        d="M22.05 15.258v8.734h3.793s1.079-.11 1.157-1.34V11.458l-4.95 3.799Z"
      />
      <path
        fill="#C5221F"
        d="M9.948 24v-8.927l-.008-.006L9.948 24ZM9.94 8.524l-1.564-1.13C5.602 5.91 5 9.177 5 9.177v2.288l4.94 3.602V8.524Z"
      />
      <path fill="#C5221F" d="M9.94 8.524v6.543l.008.006V8.531l-.008-.007Z" />
      <path
        fill="#4285F4"
        d="M5 11.467v11.192A1.35 1.35 0 0 0 6.157 24h3.792l-.009-8.933-4.94-3.6Z"
      />
    </svg>
  );
};

const Viber = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 32 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 15.3785C30 6.20699 26.7692 2 16 2C5.23077 2 2 6.20699 2 15.3785C2 21.9055 3.63629 25.9182 8.46154 27.6895V30.7774C8.46154 31.9141 9.88769 32.4332 10.6264 31.5656L13.1164 28.6411C14.0113 28.7185 14.9713 28.7569 16 28.7569C26.7692 28.7569 30 24.5499 30 15.3785ZM13.7113 26.5316C14.4251 26.5882 15.1872 26.6164 16 26.6164C25.1124 26.6164 27.8462 23.0825 27.8462 15.3785C27.8462 7.67443 25.1124 4.14055 16 4.14055C6.88757 4.14055 4.15385 7.67443 4.15385 15.3785C4.15385 20.8239 5.51965 24.1859 9.53846 25.6891V30.2639C9.53846 30.6627 10.0389 30.8449 10.2981 30.5404L13.7113 26.5316Z"
        fill="#BFC8D0"
      />
      <path
        d="M16 25.8548C15.1766 25.8548 14.4047 25.8262 13.6815 25.7685L10.224 29.845C9.96145 30.1546 9.45455 29.9693 9.45455 29.5638V24.9119C5.38354 23.3834 4 19.9647 4 14.4274C4 6.59346 6.76923 3 16 3C25.2308 3 28 6.59346 28 14.4274C28 22.2613 25.2308 25.8548 16 25.8548Z"
        fill="#9179EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 14.3785C30 5.20699 26.7692 1 16 1C5.23077 1 2 5.20699 2 14.3785C2 20.9055 3.63629 24.9182 8.46154 26.6895V29.7774C8.46154 30.9141 9.88769 31.4332 10.6264 30.5656L13.1164 27.6411C14.0113 27.7185 14.9713 27.7569 16 27.7569C26.7692 27.7569 30 23.5499 30 14.3785ZM13.7113 25.5316C14.4251 25.5882 15.1872 25.6164 16 25.6164C25.1124 25.6164 27.8462 22.0825 27.8462 14.3785C27.8462 6.67443 25.1124 3.14055 16 3.14055C6.88757 3.14055 4.15385 6.67443 4.15385 14.3785C4.15385 19.8239 5.51965 23.1859 9.53846 24.6891V29.2639C9.53846 29.6627 10.0389 29.8449 10.2981 29.5404L13.7113 25.5316Z"
        fill="white"
      />
      <path
        d="M11.5432 12.1345L11.5026 12.157L11.4668 12.1866C11.1902 12.4154 10.7756 13.0434 11.1388 13.8197C11.4414 14.4665 12.1157 15.7874 13.3005 16.7826C14.4592 17.756 15.6965 18.2795 16.5092 18.4509L16.5603 18.4617H16.6069C16.6091 18.4619 16.614 18.4624 16.6219 18.4636C16.6412 18.4663 16.6645 18.4703 16.7012 18.4767L16.7874 17.9842L16.7012 18.4767C16.7075 18.4778 16.714 18.479 16.7208 18.4802C16.9709 18.5244 17.5704 18.6304 18.0729 18.1297C18.3954 17.8083 18.6898 17.4732 18.8165 17.3225C18.9055 17.2413 19.1956 17.0731 19.5626 17.1972C20.2576 17.4321 21.0839 17.9621 21.4833 18.2308C21.7925 18.439 22.4924 18.9404 22.8079 19.1682L22.8082 19.1684C22.8344 19.1873 22.8959 19.2493 22.9291 19.3354C22.9557 19.4042 22.97 19.4988 22.9061 19.6357C22.7875 19.8895 22.4266 20.374 21.9378 20.7978C21.4401 21.2294 20.9222 21.5 20.5072 21.5C20.5087 21.5 20.5072 21.4998 20.5025 21.4992C20.484 21.4967 20.4153 21.4874 20.2792 21.4568C20.1262 21.4225 19.9195 21.3686 19.6669 21.2926C19.1622 21.1407 18.485 20.904 17.7029 20.5675C16.1375 19.8941 14.1668 18.8277 12.3218 17.2572C11.1613 16.2694 10.0664 14.9036 9.2138 13.6251C8.35407 12.3358 7.77896 11.1932 7.62244 10.6655L7.61148 10.6285L7.595 10.5937C7.55603 10.5114 7.50112 10.3355 7.50002 10.136C7.49895 9.94333 7.54725 9.75923 7.67465 9.60657C8.09467 9.10322 8.53938 8.60859 9.52049 8.13395C9.61188 8.08974 9.75504 8.05076 9.89575 8.04849C10.04 8.04617 10.1152 8.082 10.1452 8.10835C10.5206 8.43751 11.1025 9.01857 11.4945 9.51513C11.6971 9.77164 11.9418 10.0975 12.1458 10.3806C12.2478 10.5222 12.3377 10.6506 12.4062 10.7527C12.4405 10.8039 12.4679 10.8462 12.4881 10.8788C12.5019 10.9012 12.5093 10.9143 12.5124 10.9199C12.5141 10.9256 12.5218 10.9498 12.5286 10.9939C12.5371 11.0494 12.5411 11.1177 12.5354 11.1891C12.5235 11.3351 12.4755 11.4524 12.3892 11.5315C12.0962 11.7998 11.699 12.0482 11.5432 12.1345ZM16.2766 6.51613C16.2769 6.51585 16.2772 6.51557 16.2775 6.51527C16.2847 6.50852 16.2994 6.5 16.3226 6.5C20.3145 6.5 23.4984 9.53785 23.5 13.223C23.4994 13.2239 23.4983 13.2251 23.4967 13.2267C23.4895 13.2334 23.4747 13.2419 23.4516 13.2419C23.4285 13.2419 23.4137 13.2334 23.4065 13.2267C23.4049 13.2251 23.4039 13.2239 23.4032 13.223C23.4016 9.49946 20.2032 6.53226 16.3226 6.53226C16.2994 6.53226 16.2847 6.52374 16.2775 6.51699C16.2772 6.51669 16.2769 6.5164 16.2766 6.51613ZM16.2775 10.646C16.2772 10.6457 16.2769 10.6454 16.2766 10.6452C16.2769 10.6449 16.2772 10.6446 16.2775 10.6443C16.2847 10.6376 16.2994 10.629 16.3226 10.629C17.8916 10.629 19.1113 11.8182 19.1129 13.223C19.1123 13.2239 19.1112 13.2251 19.1096 13.2267C19.1024 13.2334 19.0877 13.2419 19.0645 13.2419C19.0414 13.2419 19.0266 13.2334 19.0194 13.2267C19.0178 13.2251 19.0168 13.2239 19.0161 13.223C19.0145 11.7799 17.7803 10.6613 16.3226 10.6613C16.2994 10.6613 16.2847 10.6528 16.2775 10.646ZM16.2775 8.5815C16.2772 8.58121 16.2769 8.58092 16.2766 8.58065C16.2769 8.58037 16.2772 8.58008 16.2775 8.57979C16.2847 8.57304 16.2994 8.56452 16.3226 8.56452C19.1031 8.56452 21.3048 10.678 21.3065 13.223C21.3058 13.2239 21.3048 13.2251 21.3032 13.2267C21.296 13.2334 21.2812 13.2419 21.2581 13.2419C21.2349 13.2419 21.2201 13.2334 21.213 13.2267C21.2114 13.2251 21.2103 13.2239 21.2097 13.223C21.2081 10.6397 18.9917 8.59677 16.3226 8.59677C16.2994 8.59677 16.2847 8.58825 16.2775 8.5815Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
};
const ArrowDown = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 15L12 10L7 15"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Heart = () => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
      <mask id="path-1-inside-1_2065_2481" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6876 0.828735C12.6613 0.828735 10.8951 1.96999 10.0001 3.64247C9.10502 1.96996 7.34001 0.828735 5.31253 0.828735C2.3838 0.828735 0 3.21253 0 6.14127C0 12.6263 6.79629 16.7776 9.71631 18.2613H9.72998C9.8125 18.3014 9.90247 18.3288 10 18.3288C10.0975 18.3288 10.1875 18.3014 10.27 18.2613H10.2837C13.2037 16.7776 20 12.6263 20 6.14127C20 3.21253 17.6175 0.828735 14.6875 0.828735"
        />
      </mask>
      <path
        d="M10.0001 3.64247L9.11837 4.1143L10.0001 5.76188L10.8818 4.1143L10.0001 3.64247ZM9.71631 18.2613L9.2633 19.1528L9.47681 19.2613H9.71631V18.2613ZM9.72998 18.2613L10.1665 17.3616L9.95977 17.2613H9.72998V18.2613ZM10.27 18.2613V17.2613H10.0402L9.83347 17.3617L10.27 18.2613ZM10.2837 18.2613V19.2613H10.5232L10.7367 19.1528L10.2837 18.2613ZM14.6876 -0.171265C12.277 -0.171265 10.1799 1.18691 9.11837 3.17064L10.8818 4.1143C11.6102 2.75307 13.0457 1.82874 14.6876 1.82874V-0.171265ZM10.8817 3.17064C9.82021 1.187 7.72447 -0.171265 5.31253 -0.171265V1.82874C6.95555 1.82874 8.38984 2.75293 9.11837 4.1143L10.8817 3.17064ZM5.31253 -0.171265C1.83151 -0.171265 -1 2.66025 -1 6.14127H1C1 3.76482 2.93608 1.82874 5.31253 1.82874V-0.171265ZM-1 6.14127C-1 9.7556 0.896169 12.6556 3.06126 14.7891C5.22892 16.9251 7.75942 18.3887 9.2633 19.1528L10.1693 17.3698C8.75317 16.6502 6.42553 15.2963 4.46503 13.3645C2.50198 11.4301 1 9.01197 1 6.14127H-1ZM9.71631 19.2613H9.72998V17.2613H9.71631V19.2613ZM9.29346 19.161C9.46979 19.2466 9.71043 19.3288 10 19.3288V17.3288C10.0945 17.3288 10.1552 17.3562 10.1665 17.3616L9.29346 19.161ZM10 19.3288C10.2896 19.3288 10.5302 19.2466 10.7066 19.161L9.83347 17.3617C9.84481 17.3562 9.90551 17.3288 10 17.3288V19.3288ZM10.27 19.2613H10.2837V17.2613H10.27V19.2613ZM10.7367 19.1528C12.2406 18.3887 14.7711 16.9251 16.9387 14.7891C19.1038 12.6556 21 9.7556 21 6.14127H19C19 9.01197 17.498 11.4301 15.535 13.3645C13.5745 15.2963 11.2468 16.6502 9.83069 17.3698L10.7367 19.1528ZM21 6.14127C21 2.66041 18.17 -0.171265 14.6875 -0.171265V1.82874C17.0651 1.82874 19 3.76465 19 6.14127H21Z"
        fill="black"
        mask="url(#path-1-inside-1_2065_2481)"
      />
    </svg>
  );
};

const NotFoundPage = () => {
  return (
    <svg
      id="visual"
      viewBox="0 0 1200 540"
      width="1200"
      height="540"
      version="1.1"
    >
      <rect x="0" y="0" width="1200" height="540" fill="transparent"></rect>
      <g transform="translate(665.3170091807852 340.2879931882429)">
        <path
          d="M195.6 -392.3C211.2 -329.8 152.4 -191.9 118.6 -113.9C84.9 -36 76.2 -18 91.1 8.6C105.9 35.2 144.3 70.3 138.9 80.4C133.5 90.5 84.2 75.6 53.8 109.2C23.3 142.7 11.7 224.9 -22.8 264.4C-57.3 304 -114.7 300.9 -150 270.2C-185.4 239.4 -198.8 181 -183.6 131.3C-168.5 81.7 -124.7 40.8 -164.4 -22.9C-204.1 -86.7 -327.2 -173.3 -328.8 -199.5C-330.4 -225.6 -210.4 -191.2 -135.4 -219.3C-60.3 -247.5 -30.2 -338.3 29.9 -390.1C90 -441.9 180 -454.8 195.6 -392.3"
          fill="#1d2354"
        ></path>
      </g>
    </svg>
  );
};

const HeartRemove = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M19.5 10c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5 5h-5v-1h5v1zm-6.527 4.593c-1.108 1.086-2.275 2.219-3.473 3.407-6.43-6.381-12-11.147-12-15.808 0-6.769 8.852-8.346 12-2.944 3.125-5.362 12-3.848 12 2.944 0 .746-.156 1.496-.423 2.253-1.116-.902-2.534-1.445-4.077-1.445-3.584 0-6.5 2.916-6.5 6.5 0 2.063.97 3.901 2.473 5.093z" />
    </svg>
  );
};

const SearchBar = () => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 24 24"
    >
      <path
        d="m15.97 17.031c-1.479 1.238-3.384 1.985-5.461 1.985-4.697 0-8.509-3.812-8.509-8.508s3.812-8.508 8.509-8.508c4.695 0 8.508 3.812 8.508 8.508 0 2.078-.747 3.984-1.985 5.461l4.749 4.75c.146.146.219.338.219.531 0 .587-.537.75-.75.75-.192 0-.384-.073-.531-.22zm-5.461-13.53c-3.868 0-7.007 3.14-7.007 7.007s3.139 7.007 7.007 7.007c3.866 0 7.007-3.14 7.007-7.007s-3.141-7.007-7.007-7.007z"
        fillRule="nonzero"
        fill="#000"
      />
    </svg>
  );
};

const ArrowTop = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 15L12 10L7 15"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowRight = () => {
  return (
    <svg
      fill="#000000"
      height="17px"
      width="17px"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 512.005 512.005"
    >
      <g>
        <g>
          <path
            d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005
			L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251
			l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"
          />
        </g>
      </g>
    </svg>
  );
};

const ArrowLeft = () => {
  return (
    <svg
      fill="#000000"
      height="17px"
      width="17px"
      version="1.1"
      id="Layer_1"
      viewBox="0 0 512.006 512.006"
    >
      <g>
        <g>
          <path
            d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0
			L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251
			c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"
          />
        </g>
      </g>
    </svg>
  );
};

const Quotes = () => {
  return (
    <svg xmlSpace="preserve" width={800} height={800} viewBox="0 0 1200 1200">
      <path d="M518.474 105.344C305.831 120.286.168 154.236 0 570.687v523.97h474.504v-560.61H316.946C306.965 384.354 430.23 345.701 564.274 316.03l-45.8-210.686zm635.724 0c-212.643 14.942-518.306 48.893-518.473 465.343v523.97h474.505v-560.61H952.672C942.689 384.354 1065.956 345.701 1200 316.03l-45.802-210.686z" />
    </svg>
  );
};

const Location = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
    >
      <path
        d="M498.069 786.871s303.32-237.507 303.32-409.31-135.8-311.076-303.32-311.076-303.32 139.273-303.32 311.076 303.32 409.31 303.32 409.31z m0-682.312c146.614 0 265.466 121.438 265.466 271.239S498.834 741.519 498.834 741.519 232.603 525.598 232.603 375.798s118.852-271.239 265.466-271.239z m0 416.907c52.349 0 94.788-42.438 94.788-94.788v-37.915c0-52.349-42.438-94.788-94.788-94.788s-94.788 42.438-94.788 94.788v37.915c0 52.349 42.438 94.788 94.788 94.788z m-56.873-132.703c0-31.411 25.462-56.873 56.873-56.873s56.873 25.462 56.873 56.873v37.915c0 31.411-25.462 56.873-56.873 56.873s-56.873-25.462-56.873-56.873v-37.915z m246.448 417.066l-113.745 0.415v-0.415H232.663s-39.1 0-37.915-37.915c1.185-37.915 37.915-37.915 37.915-37.915h56.873s18.366-0.593 18.958-18.958c0.593-18.366-18.958-18.958-18.958-18.958h-56.873s-75.83-1.185-75.83 75.83 75.83 75.83 75.83 75.83h132.703v0.882h322.278s39.1 0 37.915 37.621c-1.185 37.621-37.915 37.621-37.915 37.621h-151.66s-18.958 0.298-18.958 18.664c0 18.364 18.958 18.958 18.958 18.958h151.66s75.83 1.175 75.83-75.242-75.83-76.418-75.83-76.418z"
        fill="#25EF25"
      />
    </svg>
  );
};

const LocationMap = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M11.239 7.237c-.004-.009-.288-.017-.24-.078l.137-.085c.013-.077.072-.162-.007-.304l.047-.125-.1.029s.141-.606.33-.332l-.08.093c.122.122.155.426.195.623.115.06.294.071.088.175.106-.018-.561.286-.648.161-.065-.076.288-.127.278-.157zm-.715-.159c-.077.078.003.128.082.094.114-.05.269-.048.284-.202l.073-.091-.101-.135c-.06-.012-.1.064-.137.095l-.066.017-.062.08.007.044-.08.098zm7 9.167l-.733-1.206-.724-1.186c-.73-1.194-1.388-2.276-1.961-3.296l-.07.067c-.376.156-.942-.509-1.339-.531.192.03.018-.49.018-.524-.153-.189-1.123.021-1.378.055-.479.063-.979.057-1.346.355-.258.21-.262.551-.524.716-.17.106-.356.072-.502.209-.258.245-.553.607-.697.929-.062.135.077.458.043.632-.336 1.063.085 2.538 1.375 2.701.312.039.638.209.955.114.252-.076.474-.248.745-.268.377-.025.22.529.737.379.251-.074.365.172.365.359-.084.391-.268.609.088.883.242.188.442.456.486.78.026.182.196.494-.015.602-.149.075-.259.507-.257.649.031.165.365.481.466.621.146.2.039.436.158.663.122.232.237.41.323.645.111.324.958-.007 1.156-.006.673.004 1.014-.944 1.487-1.235.267-.165.192-.616.51-.848.296-.215.608-.344.636-.741.021-.344-.259-1.062-.104-1.353l.102-.165zm-7.301-7.76c.041.172-.119.645-.154.795-.031.138.442.226.415.295.004-.008.642-.22.705-.275l.144-.323c.121-.081.248-.146.384-.196l.164-.285c.056-.021.71-.123.756-.101.165.075.469.389.583.531l.041.032c-.326-.67-.59-1.314-.796-1.942l-.083.036c-.222 0-.528.251-.663.405-.095.104-.669.337-.732.33.33.035.314.276.288.482-.068.476-1.096.035-1.052.216zm10.904 5.049c-.277 4.807-4.253 8.623-9.13 8.623-2.603 0-4.951-1.086-6.618-2.83-.198-.208-.346-.7-.02-.9l.331-.085c.259-.22-.242-1.111-.044-1.254.617-.441.324-.982-.055-1.429-.161-.19-1.043-1.1-1.143-.937.074-.249-.16-.85-.302-1.087-.239-.398-.553-.643-.679-1.081-.05-.174-.05-.704-.153-.826-.041-.05-.358-.185-.347-.257.305-1.82 1.147-3.458 2.364-4.751l.821-.33c.515-.773.545-.173 1.008-.375.154 0 .331-.634.496-.734.289-.185.068-.185.015-.27-.112-.184 2.411-1.103 2.453-.938.034.14-1.249.809-1.108.788-.326.043-.388.627-.328.625.163-.005 1.182-.774 1.657-.61.466.161 1.301-.37 1.627-.64l.04-.038c.029-.761.195-1.494.481-2.172l-.493-.026c-6.075 0-11 4.925-11 11s4.925 11 11 11c6.074 0 11-4.925 11-11 0-.764-.078-1.509-.227-2.229-.491.864-1.044 1.779-1.646 2.763zm1.873-9.1c0 2.45-1.951 5.373-4.5 9.566-2.549-4.193-4.5-7.116-4.5-9.566 0-2.449 2.139-4.434 4.5-4.434s4.5 1.985 4.5 4.434zm-2.75.066c0-.966-.784-1.75-1.75-1.75s-1.75.784-1.75 1.75.784 1.75 1.75 1.75 1.75-.784 1.75-1.75z" />
    </svg>
  );
};

const Cup = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M21.9999 8.16234L21.9999 8.23487C21.9999 9.09561 21.9999 9.52598 21.7927 9.8781C21.5855 10.2302 21.2093 10.4392 20.4569 10.8572L19.6636 11.298C20.2102 9.44984 20.3926 7.46414 20.4601 5.76597C20.4629 5.69316 20.4662 5.61945 20.4695 5.54497L20.4718 5.49279C21.1231 5.71896 21.4887 5.88758 21.7168 6.20408C22 6.59692 22 7.11873 21.9999 8.16234Z"
        fill="#1C274C"
      />
      <path
        d="M2 8.16234L2 8.23487C2.00003 9.09561 2.00004 9.52598 2.20723 9.8781C2.41442 10.2302 2.79063 10.4392 3.54305 10.8572L4.33681 11.2982C3.79007 9.45001 3.60767 7.46422 3.54025 5.76597C3.53736 5.69316 3.5341 5.61945 3.53081 5.54497L3.5285 5.49266C2.87701 5.7189 2.51126 5.88752 2.2831 6.20408C1.99996 6.59692 1.99997 7.11873 2 8.16234Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 2C13.7837 2 15.2531 2.15709 16.3771 2.34674C17.5159 2.53887 18.0852 2.63494 18.5609 3.22083C19.0367 3.80673 19.0115 4.43998 18.9612 5.70647C18.7886 10.0545 17.8503 15.4853 12.75 15.9657V19.5H14.1802C14.6569 19.5 15.0673 19.8365 15.1608 20.3039L15.35 21.25H18C18.4142 21.25 18.75 21.5858 18.75 22C18.75 22.4142 18.4142 22.75 18 22.75H6C5.58579 22.75 5.25 22.4142 5.25 22C5.25 21.5858 5.58579 21.25 6 21.25H8.65L8.83922 20.3039C8.93271 19.8365 9.34312 19.5 9.8198 19.5H11.25V15.9657C6.14996 15.4851 5.21169 10.0544 5.03907 5.70647C4.98879 4.43998 4.96365 3.80673 5.43937 3.22083C5.91508 2.63494 6.48445 2.53887 7.62318 2.34674C8.74724 2.15709 10.2166 2 12.0002 2ZM12.9524 6.19887L12.8541 6.02251C12.4741 5.34084 12.2841 5 12 5C11.7159 5 11.5259 5.34084 11.1459 6.02251L11.0476 6.19887C10.9397 6.39258 10.8857 6.48944 10.8015 6.55334C10.7173 6.61725 10.6125 6.64097 10.4028 6.68841L10.2119 6.73161C9.47396 6.89857 9.10501 6.98205 9.01723 7.26432C8.92945 7.54659 9.18097 7.84072 9.68403 8.42898L9.81418 8.58117C9.95713 8.74833 10.0286 8.83191 10.0608 8.93532C10.0929 9.03872 10.0821 9.15023 10.0605 9.37327L10.0408 9.57632C9.96476 10.3612 9.92674 10.7536 10.1565 10.9281C10.3864 11.1025 10.7318 10.9435 11.4227 10.6254L11.6014 10.5431C11.7978 10.4527 11.8959 10.4075 12 10.4075C12.1041 10.4075 12.2022 10.4527 12.3986 10.5431L12.5773 10.6254C13.2682 10.9435 13.6136 11.1025 13.8435 10.9281C14.0733 10.7536 14.0352 10.3612 13.9592 9.57632L13.9395 9.37327C13.9179 9.15023 13.9071 9.03872 13.9392 8.93532C13.9714 8.83191 14.0429 8.74833 14.1858 8.58117L14.316 8.42898C14.819 7.84072 15.0706 7.54659 14.9828 7.26432C14.895 6.98205 14.526 6.89857 13.7881 6.73161L13.5972 6.68841C13.3875 6.64097 13.2827 6.61725 13.1985 6.55334C13.1143 6.48944 13.0603 6.39258 12.9524 6.19887Z"
        fill="#1C274C"
      />
    </svg>
  );
};

const ContactFooter = () => {
  return (
    <svg width={3472} height={400} preserveAspectRatio="none">
      <g fill="none" mask='url("#a")'>
        <path fill='url("#b")' d="M0 0h3472v400H0z" />
        <use xlinkHref="#c" />
        <use xlinkHref="#c" x={720} />
        <use xlinkHref="#c" x={1440} />
        <use xlinkHref="#c" x={2160} />
        <use xlinkHref="#c" x={2880} />
      </g>
      <defs>
        <path id="h" d="M-1 0a1 1 0 1 0 2 0 1 1 0 1 0-2 0z" />
        <path id="e" d="M-3 0a3 3 0 1 0 6 0 3 3 0 1 0-6 0z" />
        <path id="g" d="M-5 0A5 5 0 1 0 5 0 5 5 0 1 0-5 0z" />
        <path id="f" d="m2-2-4 4z" />
        <path id="d" d="M6-6-6 6z" />
        <path id="i" d="m30-30-60 60z" />
        <linearGradient
          id="b"
          x1="22.12%"
          x2="77.88%"
          y1="-192%"
          y2="292%"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#0e2a47" />
          <stop offset={1} stopColor="#00459e" />
        </linearGradient>
        <mask id="a">
          <path fill="#fff" d="M0 0h3472v400H0z" />
        </mask>
      </defs>
      <symbol id="c">
        <use xlinkHref="#d" x={30} y={30} stroke="#1c538e" />
        <use xlinkHref="#e" x={30} y={90} stroke="#1c538e" />
        <use xlinkHref="#f" x={30} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={30} y={210} stroke="#1c538e" />
        <use xlinkHref="#e" x={30} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={30} y={330} stroke="#1c538e" />
        <use xlinkHref="#h" x={30} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={90} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={90} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={90} y={150} stroke="#1c538e" />
        <use xlinkHref="#d" x={90} y={210} stroke="#1c538e" />
        <use xlinkHref="#h" x={90} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={90} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={90} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={150} y={30} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={90} stroke="#1c538e" />
        <use xlinkHref="#h" x={150} y={150} stroke="#1c538e" />
        <use xlinkHref="#h" x={150} y={210} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={270} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={150} y={390} stroke="#1c538e" />
        <use xlinkHref="#d" x={210} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={210} y={90} stroke="#1c538e" />
        <use xlinkHref="#d" x={210} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={210} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={330} stroke="#1c538e" />
        <use xlinkHref="#g" x={210} y={390} stroke="#1c538e" />
        <use xlinkHref="#i" x={270} y={30} stroke="#1c538e" strokeWidth={3} />
        <use xlinkHref="#d" x={270} y={90} stroke="#1c538e" />
        <use xlinkHref="#h" x={270} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={270} y={210} stroke="#1c538e" />
        <use xlinkHref="#e" x={270} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={270} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={270} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={330} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={330} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={330} y={150} stroke="#1c538e" />
        <use xlinkHref="#h" x={330} y={210} stroke="#1c538e" />
        <use xlinkHref="#f" x={330} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={330} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={330} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={390} y={30} stroke="#1c538e" />
        <use xlinkHref="#g" x={390} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={390} y={150} stroke="#1c538e" />
        <use xlinkHref="#h" x={390} y={210} stroke="#1c538e" />
        <use xlinkHref="#f" x={390} y={270} stroke="#1c538e" />
        <use xlinkHref="#h" x={390} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={390} y={390} stroke="#1c538e" />
        <use xlinkHref="#h" x={450} y={30} stroke="#1c538e" />
        <use xlinkHref="#d" x={450} y={90} stroke="#1c538e" />
        <use xlinkHref="#e" x={450} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={450} y={210} stroke="#1c538e" />
        <use xlinkHref="#d" x={450} y={270} stroke="#1c538e" />
        <use xlinkHref="#d" x={450} y={330} stroke="#1c538e" />
        <use xlinkHref="#h" x={450} y={390} stroke="#1c538e" />
        <use xlinkHref="#g" x={510} y={30} stroke="#1c538e" />
        <use xlinkHref="#h" x={510} y={90} stroke="#1c538e" />
        <use xlinkHref="#g" x={510} y={150} stroke="#1c538e" />
        <use xlinkHref="#f" x={510} y={210} stroke="#1c538e" />
        <use xlinkHref="#d" x={510} y={270} stroke="#1c538e" />
        <use xlinkHref="#g" x={510} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={510} y={390} stroke="#1c538e" />
        <use xlinkHref="#d" x={570} y={30} stroke="#1c538e" />
        <use xlinkHref="#g" x={570} y={90} stroke="#1c538e" />
        <use xlinkHref="#f" x={570} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={570} y={210} stroke="#1c538e" />
        <use xlinkHref="#d" x={570} y={270} stroke="#1c538e" />
        <use xlinkHref="#f" x={570} y={330} stroke="#1c538e" />
        <use xlinkHref="#d" x={570} y={390} stroke="#1c538e" />
        <use xlinkHref="#f" x={630} y={30} stroke="#1c538e" />
        <use xlinkHref="#i" x={630} y={90} stroke="#1c538e" strokeWidth={3} />
        <use xlinkHref="#g" x={630} y={150} stroke="#1c538e" />
        <use xlinkHref="#i" x={630} y={210} stroke="#1c538e" strokeWidth={3} />
        <use xlinkHref="#g" x={630} y={270} stroke="#1c538e" />
        <use xlinkHref="#d" x={630} y={330} stroke="#1c538e" />
        <use xlinkHref="#e" x={630} y={390} stroke="#1c538e" />
        <use xlinkHref="#h" x={690} y={30} stroke="#1c538e" />
        <use xlinkHref="#g" x={690} y={90} stroke="#1c538e" />
        <use xlinkHref="#f" x={690} y={150} stroke="#1c538e" />
        <use xlinkHref="#g" x={690} y={210} stroke="#1c538e" />
        <use xlinkHref="#g" x={690} y={270} stroke="#1c538e" />
        <use xlinkHref="#e" x={690} y={330} stroke="#1c538e" />
        <use xlinkHref="#f" x={690} y={390} stroke="#1c538e" />
      </symbol>
    </svg>
  );
};

const ContactContent = () => {
  return (
    <svg
      version="1.1"
      width="3440"
      height="400"
      preserveAspectRatio="none"
      viewBox="0 0 3440 400"
    >
      <g mask='url("#SvgjsMask1017")' fill="none">
        <path
          d="M1403.64 472.91C1730.77 472.69 2049.78 328.47 2704.13 328.01 3358.48 327.55 3677.4 180.25 4004.62 180.01"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M1120.38 424.77C1435.02 421.52 1724.44 83.28 2331.75 83.16 2939.05 83.04 3237.51 246.79 3543.11 247.16"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M1600.33 439.63C1902.71 438.89 2195.88 235.34 2792.49 235.32 3389.1 235.3 3685.48 339.22 3984.65 339.32"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M293.97 436.76C695.02 436.22 1087.63 213.61 1882.56 213.58 2677.49 213.55 3073.28 309.54 3471.15 309.58"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
        <path
          d="M217.92 459.96C496.14 459.07 763.43 254.7 1311.69 254.6 1859.95 254.5 1858.58 304.6 2405.46 304.6 2952.34 304.6 3225.5 254.61 3499.23 254.6"
          stroke="rgba(51,121,194,0.58)"
          strokeWidth="2"
        ></path>
      </g>
      <defs>
        <mask id="SvgjsMask1017">
          <rect width="3440" height="400" fill="#ffffff"></rect>
        </mask>
      </defs>
    </svg>
  );
};

export const Filter = () => {
  return (
    <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 6H19M21 12H16M21 18H16M7 20V13.5612C7 13.3532 7 13.2492 6.97958 13.1497C6.96147 13.0615 6.93151 12.9761 6.89052 12.8958C6.84431 12.8054 6.77934 12.7242 6.64939 12.5617L3.35061 8.43826C3.22066 8.27583 3.15569 8.19461 3.10948 8.10417C3.06849 8.02393 3.03853 7.93852 3.02042 7.85026C3 7.75078 3 7.64677 3 7.43875V5.6C3 5.03995 3 4.75992 3.10899 4.54601C3.20487 4.35785 3.35785 4.20487 3.54601 4.10899C3.75992 4 4.03995 4 4.6 4H13.4C13.9601 4 14.2401 4 14.454 4.10899C14.6422 4.20487 14.7951 4.35785 14.891 4.54601C15 4.75992 15 5.03995 15 5.6V7.43875C15 7.64677 15 7.75078 14.9796 7.85026C14.9615 7.93852 14.9315 8.02393 14.8905 8.10417C14.8443 8.19461 14.7793 8.27583 14.6494 8.43826L11.3506 12.5617C11.2207 12.7242 11.1557 12.8054 11.1095 12.8958C11.0685 12.9761 11.0385 13.0615 11.0204 13.1497C11 13.2492 11 13.3532 11 13.5612V17L7 20Z"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Icon = ({ icon }) => {
  const selectedIcon = {
    cup: <Cup />,
    viber: <Viber />,
    gmail: <Gmail />,
    heart: <Heart />,
    filter: <Filter />,
    quotes: <Quotes />,
    twitter: <Twitter />,
    youtube: <Youtube />,
    search: <SearchBar />,
    location: <Location />,
    whatsapp: <WhatsApp />,
    facebook: <Facebook />,
    arrowTop: <ArrowTop />,
    instagram: <Instagram />,
    arrowDown: <ArrowDown />,
    arrowLeft: <ArrowLeft />,
    arrowRight: <ArrowRight />,
    locationMap: <LocationMap />,
    heartRemove: <HeartRemove />,
    notFoundPage: <NotFoundPage />,
    contactFooter: <ContactFooter />,
    contactContent: <ContactContent />,
    instagramVector: <InstagramVector />,
  };

  return <>{selectedIcon[icon]}</>;
};

export default Icon;
